import styled, {css} from 'styled-components'

export const Trigger = styled.button`

`

export const Container = styled.div`
    width: 228px;
    position: absolute;
    display: block;
    ${props => props.right && css`
        right: 8px;
    `};
    z-index: 99;
    padding: 16px;
    max-height: 60vh;
    margin-top: 16px;
    border-radius: 5px;
    background-color: ${props => props.theme.bg};
    box-shadow: -2px 5px 20px ${props => props.theme.boxShadow};

    &>h1 {
        font-size: 14px;
        color: ${({theme}) => theme.primary};
        margin: 0 0 16px;
    }
`

export const ModeContainer = styled.div`
    display: flex;

    >button {
        background: transparent;
        border: 1px solid ${({theme}) => theme.primary};
        color: ${({theme}) => theme.title};
        padding: 8px 10px;
        border-radius: 4px;
        outline: none;
        cursor: pointer;
        transition: background-color 2ms;

        :active {
            background: ${({theme}) => theme.primary}40;
        }

        :first-child {
            margin-right: 16px;
        }
    }
`

export const OptionList = styled.div`
    margin: 16px 0 0;

    >button {
        background: transparent;
        color: ${({theme}) => theme.text};
        padding: 4px 5px;
        border-radius: 4px;
        outline: none;
        cursor: pointer;
        transition: background-color 2ms;
    }
`